import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useDispatch } from 'react-redux'
import { AnyAction, Dispatch } from 'redux'

import { openRedirectModal } from 'registry/modals/actions'
import { Offer } from 'src/types/offer'
import { Registry } from 'src/types/registry'
import { RegItem } from 'src/types/regItem'
import { useGetBabylistOfferClickHandler } from '../../hooks/useGetBabylistOfferClickHandler/useGetBabylistOfferClickHandler'
import RegItemBuyingOptionsModal from '../RegItemBuyingOptionsModal/RegItemBuyingOptionsModal'

export const getButtonAccessibleText = (isBabylistOffer: boolean): string =>
  isBabylistOffer ? 'Add to Babylist cart' : 'Buy from store'

export const useGetHandleClick = (
  regItem: RegItem,
  registry: Registry,
  offer: Offer,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const handleBabylistOfferClick = useGetBabylistOfferClickHandler(
    regItem,
    setIsLoading
  )
  const dispatch = useDispatch()
  const modal = useModal()

  return () => {
    if (offer.isBabylist) {
      if (!regItem.isAvailableOnBabylist) return
      handleBabylistOfferClick()
    } else {
      handleExternalOfferClick({
        regItem,
        registry,
        offer,
        dispatch,
        closeModal: () => modal.hide(),
      })
    }
  }
}

interface HandleExternalOfferClickArgs {
  regItem: RegItem
  registry: Registry
  offer: Offer
  dispatch: Dispatch<AnyAction>
  closeModal: () => void
}

const handleExternalOfferClick = ({
  regItem,
  registry,
  offer,
  dispatch,
  closeModal,
}: HandleExternalOfferClickArgs) => {
  closeModal()
  dispatch(
    openRedirectModal({
      url: offer.url,
      storeDisplayName: offer.storeDisplayName,
      onRedirectSuccess: () => {
        NiceModal.show(RegItemBuyingOptionsModal, {
          regItemId: regItem.id,
          registry,
          variantOverride: 'DidYouPurchaseOptions',
        })
      },
      isShopRegistryView: false,
    })
  )
}
